import { TableComponent } from "./table.component";

export const Table = TableComponent;